<template>
  <div class="site-header">
    <div class="site-header__container">
      <div class="site-header__top">
        <a
          class="btn-header button-pink"
          href="/exames"
        >
          <svg-loader src="/static/images/site/exam.svg" />
          <span>Guia de Exames</span>
        </a>
        <div class="site-header__right-actions">
          <a
            class="button-pink"
            href="tel:0800-643 8100"
          >
            <svg-loader src="/static/images/site/phone.svg" />
            <span>0800-643 8100</span>
          </a>
          <a
            class="btn-header button-pink"
            href="/dashboard"
          >
            <md-icon
              id="userProfileIcon"
              class="user-profile-icon"
            >person_outline</md-icon>
            <span>Acesso Cliente</span>
          </a>
          <!-- <button class="button-pink">
            <svg-loader src="/static/images/site/dark-mode.svg"></svg-loader>
            <span>Alto contraste</span>
          </button> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader'
}
</script>

<style lang="scss">
.site-header {
  font-family: 'Exo 2', sans-serif !important;
  background-color: #fcf2f8;

  .button-pink {
    padding: 2px 14px;
    display: flex;
    align-items: center;
    font-size: 13px;
    border-radius: 0;
    height: 35px;
    color: #595959;
    font-weight: 500;
    font-family: 'Exo 2', sans-serif !important;
    text-decoration: none !important;

    &.btn-header {
      background-color: #f7dfee;
      border: 1px solid #f7dfee;
    }

    &:hover {
      background-color: #f1c6e0;
      color: #595959 !important;
    }

    .md-icon {
      min-width: 20px;
      min-height: 20px;
      width: 20px;
      height: 20px;
      fill: #7f1a55;
      font-size: 20px;
      margin-right: 8px;
      color: #7f1a55;

      path {
        fill: #7f1a55;
      }
    }
  }

  &__container {
    width: 100%;
    max-width: 1144px;
    margin: 0 auto;
  }

  &__top {
    height: 35px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__right-actions {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .button-pink {
      margin-left: 8px;
    }
  }
}
</style>
